import { createRouter, createWebHistory } from 'vue-router'
import routesConfig from '../routes/routesConfig'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routesConfig.map(route => ({
    path: route.path,
    name: route.name,
    component: route.component,
    meta: route.meta || {}
  }))
})

export default router

// Fonction helper pour générer les routes (compatible avec l'ancien système)
export function generateRoutes() {
  return routesConfig.map(route => ({
    path: route.path,
    component: route.component,
    name: route.name
  }))
}
